export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nabídky"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moje obchody"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moje inzeráty"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obchody"])}
}